export default {
    plans: [],
    currentPlan: {}
}